import React from 'react'
import { root } from './index.sass'
import { Button } from 'antd'
import useAuth from '../../hooks/useAuth'

export default function NoPermission() {
  const { signOut } = useAuth()

  return (
    <div className={root}>
      <div className='center'>
        <h1 className='title'>This account does not have permission to access this page</h1>
        <Button type='primary' style={{ marginLeft: 20 }} onClick={signOut}>
          Sign Out
        </Button>
      </div>
    </div>
  )
}
